import React, { Component } from 'react';
import { withAlert } from 'react-alert';
import { compose } from 'redux';
import UrlParse from 'url-parse';
import BasicPage from './BasicPage';
import { Link } from 'react-router-dom';
import { Card, Tabs } from 'antd';
import _ from 'lodash';

export class ApiKeyDetailPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeKey: '',
			crf_id: ''
		};
	}

	componentDidMount() {
		const path = this.props.location.pathname.split('/');
		const pathname = path[path.length - 1];
		switch (true) {
			case (pathname === 'basic'):
				this.setState({
					activeKey: 'Basic'
				});
				break;
			default:
				this.setState({
					activeKey: 'Basic'
				});
		}
	}

	componentDidUpdate(prevProps){
		// redirect to mainpage if the crf is change (from dropdown)
		const {crf_id} = JSON.parse(localStorage.getItem('crf'));
		if (crf_id !== prevProps.drawerReducer.crf_id) {
			this.props.history.push('/api-keys');
		}
	}

	_getSpecificComponent = () => {
		const { history } = this.props;
		const path = this.props.location.pathname.split('/');
		const pathname = path[path.length - 1];

		switch (true) {
			case (pathname === 'basic'):
				return <BasicPage {...this.props} />;
			default:
				// back to notice board or main page once routes not found
				history.push('/api-keys');
		}
	}

	callback = (key) => {
		const { history, location } = this.props;
		const { query } = UrlParse(location.search, true);
		const tabs = [
			{ title: 'Basic', path: `/basic?id=${query.id}` }
		];
		this.setState({
			activeKey: key
		});
		let index = tabs.findIndex(p => p.title === key);
		if (!_.isUndefined(index) && index !== -1) {
			history.push(location.pathname.split('/').slice(0, -1).join('/') + tabs[index].path);
		} else {
			history.push(location.pathname.split('/').slice(0, -1).join('/') + tabs[0].path);
		}
	}

	render(){
		const { location } = this.props;
		const { query } = UrlParse(location.search, true);
		const { activeKey } = this.state;

		const tabs = [
			{ title: 'Basic', path: `/basic?id=${query.id}` }
		];

		return(
			<React.Fragment>
				<Card style={{ marginTop: 7 }}>
					<React.Fragment>
						<p style={{ marginBottom: 10, fontSize: 11, color: '#707070' }}>
							<Link
								to="/api-keys"
								style={{ color: '#0074bc' }}
							>
								API Key Management
							</Link>  / Details </p>
						<h3 style={{ margin: 0, color: '#00080D' }}> API Key Details </h3>
					</React.Fragment>
				</Card>
				<div className="hall-custom-container">
					<Card style={{ margin: '15px 15px 0' }}>
						<Tabs
							activeKey={activeKey}
							onChange={this.callback}
							style={{ marginTop: -25, marginBottom: 5 }}
						>
							{tabs.map((tab, index) => {
								return (
									<Tabs.TabPane
										tab={tab.title}
										key={tab.title}
									>
									</Tabs.TabPane>
								);
							})}
						</Tabs>
						{this._getSpecificComponent()}
					</Card>
				</div>
			</React.Fragment>
		);
	}
}

export default compose(withAlert())(ApiKeyDetailPage);
